export const MAX_INPUT_LENGTH = 255;
export const MAINTENANCE_POLLING_INTERVALL = 3 * 60 * 1000;
export const TENANT_BILD = "BILD";
export const MAX_OBJECT_DESCRIPTION_LENGTH = 200;
